import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { ApiClientError } from '@/lib/api-client';
import { confirmDelay, fetchBatchCloseContext, recordDelayReason } from './api';
import type { BatchCloseContext } from './types';

const KEY = 'batch-close-context' as const;

/** Read-only batch close context (case_code + close_deadline + status). */
export const useBatchCloseContext = (batchId: string | undefined) => {
  return useQuery<BatchCloseContext, ApiClientError>({
    queryKey: [KEY, batchId],
    queryFn: () => fetchBatchCloseContext(batchId!),
    enabled: !!batchId,
  });
};

/** POST record the delay reason for an overdue close. */
export const useRecordDelayReason = (batchId: string | undefined) => {
  const qc = useQueryClient();
  return useMutation<BatchCloseContext, ApiClientError, string>({
    mutationFn: (reason) => recordDelayReason(batchId!, reason),
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY, batchId] }),
  });
};

/** POST confirm the recorded delay. */
export const useConfirmDelay = (batchId: string | undefined) => {
  const qc = useQueryClient();
  return useMutation<BatchCloseContext, ApiClientError, void>({
    mutationFn: () => confirmDelay(batchId!),
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY, batchId] }),
  });
};
